<template>
  <v-card>
    <v-card-title class="title">Soporte</v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="subject" label="Asunto"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="description"
              name="input-7-1"
              label="Descripción"
              value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
              hint="Máximo 300 caracteres"
              outlined
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      subject: "",
      description: "",
    };
  },
};
</script>

<style>
</style>